import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { RequestBuyCredits } from '@shared/dto/+workspace/workspace_payment_transaction.ts/_requests/request_buy_credits';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const remote_stripe_checkout_session_create = createAsyncThunkSafe<string, RequestBuyCredits>(
  ENUM__network_event_client_to_server.BILLING_STRIPE_CHECKOUT_SESSION_CREATE,
  async (request): Promise<string> => {
    return await send_to_server(ENUM__network_event_client_to_server.BILLING_STRIPE_CHECKOUT_SESSION_CREATE, request);
  },
);

export function init_remote_stripe_checkout_session_create(builder: ActionReducerMapBuilder<StateWorkspaceBilling>) {
  builder
    .addCase(remote_stripe_checkout_session_create.pending, (state, action) => {})
    .addCase(remote_stripe_checkout_session_create.rejected, (state, action) => {})
    .addCase(remote_stripe_checkout_session_create.fulfilled, (state, action: PayloadAction<string>) => {});
}
